import { derived } from 'svelte/store'

import fetchStore from '../lib/fetchStore'
import leaderboardData from '../lib/mock-data/leaderboardData'

import { stakeholdersLeaderboard } from '../urlMenu'

export default function () {
  // build our object of data calls for the home page (we imported the ones we need from the 'menu' above)
  const dataCalls = {
    stakeholdersLeaderboard: stakeholdersLeaderboard,
  }

  // This line doesn't look like much, but this function call is what returns the mains Svelte stores after fetching the data.
  const [data, loading, error] = fetchStore(dataCalls)

  // `data` is now a Svelte store. We can build upon the main data store we just created by using `derived()`
  // to create transformations our components can import and use directly.
  // this should be the last place we touch the data before it's dropped into the component.
  const stakeholdersLeaderboardStore = derived(data, ($data)=>{
    if($data.stakeholdersLeaderboard) {
      console.log('found data', $data.stakeholdersLeaderboard)
      return $data.stakeholdersLeaderboard
    } else {
      console.log('did not find data')
      return leaderboardData()
    }
  }, [])
  
  return [
    data, 
    loading, 
    error,

    stakeholdersLeaderboardStore
  ]
}